// extracted by mini-css-extract-plugin
export default {"wrapper":"checkTitle_wrapper__3HyFA"};